import { render, staticRenderFns } from "./CreateLocaleDialog.vue?vue&type=template&id=51fe522c&scoped=true&"
import script from "./CreateLocaleDialog.vue?vue&type=script&lang=js&"
export * from "./CreateLocaleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fe522c",
  null
  
)

export default component.exports